import { useCallback } from "react";
import { SERVER_HOST } from "../../constants/config";
import { getEkycHeaders } from "../../utils/ekycHeaders";

const BaseAPIUrl = SERVER_HOST;

const useMyKadService = () => {

  const extractNameAndIDNumber = useCallback(
    async (formData) => {
      const config = {
        method: "post",
        headers: getEkycHeaders(),
        body: formData,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mykad-verification/extract-name-and-id-number",
        config
      ).then((response) => response.json());
    },
    []
  );

  const uploadFront = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: getEkycHeaders(),
        body: params,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mykad-verification/upload-front",
        config
      ).then((response) => response.json());
    },
    []
  );

  const verifyFront = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mykad-verification/verify-front",
        config
      ).then((response) => response.json());
    },
    []
  );

  const uploadBack = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: getEkycHeaders(),
        body: params,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mykad-verification/upload-back",
        config
      ).then((response) => response.json());
    },
    []
  );

  const verifyBack = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mykad-verification/verify-back",
        config
      ).then((response) => response.json());
    },
    []
  );

  const verifySelfieWithMyKad = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders(),
        method: "post",
        body: params,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mykad-verification/verify-selfie-with-mykad",
        config
      ).then((response) => response.json());
    },
    []
  );

  const verifyHologram = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders(),
        method: "post",
        body: params,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mykad-verification/verify-hologram",
        config
      ).then((response) => response.json());
    },
    []
  );

  const checkResult = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mykad-verification/check-result",
        config
      ).then((response) => response.json());
    },
    []
  );

  const getMyKadRejectReason = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mykad-verification/reject-reason",
        config
      ).then((response) => response.json());
    },
    []
  );

  return {
    extractNameAndIDNumber,
    uploadFront,
    verifyFront,
    uploadBack,
    verifyBack,
    verifySelfieWithMyKad,
    verifyHologram,
    checkResult,
    getMyKadRejectReason,
  };
};

export { useMyKadService };
